export type IFlyerCatalogueResources = typeof FlyerCatalogueResources;

export const FlyerCatalogueResources = {
    paginationText: "Strona {page} / {totalPages}",
    showFlyerText: "Pokaż całą gazetkę",
    flyerPages: "Strony gazetki",
    navigateToBrand: "Więcej w {brandName}",
    share: "Udostępnij",
};
